var React = require('react');

function ArrowHomeTestimonial (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.9"},[React.createElement("path",{"d":"M-22.19 195.888L34.8216 101.84L-23.277 6","stroke":"#F5F5F5","strokeWidth":"19.4482","key":0}),React.createElement("path",{"d":"M-22.1895 241L34.8221 146.952L-23.2765 51.1121","stroke":"#FAFAFA","strokeWidth":"19.4482","key":1})]));
}

ArrowHomeTestimonial.defaultProps = {"width":"47","height":"247","viewBox":"0 0 47 247","fill":"none"};

module.exports = ArrowHomeTestimonial;

ArrowHomeTestimonial.default = ArrowHomeTestimonial;
